import { mapState } from 'vuex';
import { handleLocalStorage, routerJump } from '@/assets/js/utils.js';
export default {
  data() {
    return {
      input: ''
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config,
      homeLogo: state => state.homeLogo
    })
  },
  created() {
    gtag('event', 'pageView-page join', {
      event_category: 'pageView',
      event_label: '加入页面',
      value: 'page join'
    });
  },
  methods: {
    getQueryString(url, name) {
      let value = null;
      url = url.split('?')[1];
      if (url) {
        url = url.split('&');
        console.info(url);
        url.forEach(v => {
          const keysValue = v.split('=');
          if (keysValue[0] == name) {
            value = keysValue[1];
          }
        });
      }
      return value;
    },
    joinParty() {
      var _this$Config;
      const url = this.input.replace(/\s+/g, '');
      const isCommentator = url.includes('commentator');
      let id = null;
      if (isNaN(Number(url))) {
        if (url.indexOf('join_id') > -1) {
          if (url.indexOf('PartyID:') > -1) {
            id = url.split('PartyID:')[1];
          } else {
            id = this.getQueryString(url, 'join_id');
          }
        } else {
          id = this.getQueryString(url, 'id');
        }
      } else {
        id = url;
      }
      if (!id) {
        this.$message.error(this.$t('remainWords.enterId'));
        return;
      }
      console.info(id, isCommentator);
      sessionStorage.removeItem('enterPartyType');
      const query = {
        join_id: id,
        env: (_this$Config = this.Config) === null || _this$Config === void 0 ? void 0 : _this$Config.apiEnv,
        type: isCommentator ? 'commentator' : ''
      };
      routerJump('participate', query);
    },
    returnPage() {
      routerJump('joinOrStart');
    }
  },
  mounted() {
    handleLocalStorage('remove', 'partyInfo');
  }
};